import(/* webpackMode: "eager", webpackExports: ["GoogleSignUpButton"] */ "/home/circleci/project/apps/sb-shell/app/(recaptcha)/sign-up/GoogleSignUpButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/apps/sb-shell/app/(recaptcha)/sign-up/SignUpForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/link.js");
